import {combineReducers} from 'redux';
import common from './common';
import ats from './ats';
import hrms from './hrms';
import filter from "./filters";
import candidate from "./candidate";
import reminder from "./reminder";
import interview from "./interview";
import employee from "./employee";
import events from "./events";
import preboarding from "./preboarding";
import memorize from './memorize'

export default combineReducers({common, ats, hrms, filter, candidate, reminder, interview, employee, events ,preboarding ,memorize });
